import { SkillsList } from "@/components/agents/tabs/agent-skills";
import { Link, Navigate, createFileRoute, notFound, useLoaderData } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

/** `/agents/lair/$persona`: one of lair's agents and the company skills the whole team's lair gives it. */

export const LAIR_PERSONAS = ["planner", "developer", "creator", "tester"] as const;

export const Route = createFileRoute("/_app/agents/lair/$persona")({
  beforeLoad: ({ params }) => {
    if (!(LAIR_PERSONAS as readonly string[]).includes(params.persona)) throw notFound();
  },
  component: LairAgentPage,
});

function LairAgentPage() {
  const { t } = useTranslation();
  const { user } = useLoaderData({ from: "/_app" });
  const { persona } = Route.useParams();
  if (user.globalRole !== "admin") return <Navigate to="/" />;
  return (
    <div className="w-full space-y-6" data-testid="lair-agent">
      <div>
        <Link to="/agents" className="text-muted-foreground text-sm hover:underline">
          {t("agents.lair.back")}
        </Link>
        <p className="mt-3 font-medium text-muted-foreground text-xs uppercase tracking-wide">
          {t("agents.lair.kicker")}
        </p>
        <h1 className="font-bold text-3xl">{t(`agents.lair.personas.${persona}.name`)}</h1>
        <p className="mt-1 max-w-3xl text-muted-foreground">
          {t(`agents.lair.personas.${persona}.description`)}
        </p>
      </div>
      <h2 className="font-bold font-heading text-xl">{t("agents.tabs.skills")}</h2>
      <SkillsList
        base={`/api/agents/lair/${persona}/skills`}
        intro={t("agents.lair.skillsIntro")}
      />
    </div>
  );
}
